export function filterUpsertedRows(rows) {
  return rows.filter(
    ({ status }) => !!(status === 'N' || status === 'C' || status === 'E' || status === 'D'),
  );
}
